export const ADMIN_FACELIFT_CONFIG = {
  mode: 'light',
  themeSchema: 'orange',
  layout: 'framelessSide',
  sidebarWidth: 290,
  headerHeight: 64,
  outerGap: 24,
  contentMaxWidth: '1680px',
} as const
